// nakama.js — Config Nakama côté App Store (classements live). Env-driven, no-op si vide.
//   REACT_APP_NAKAMA_URL : ex https://nakama.docker.devhost (local) ou https://nakama.<domaine> (prod)
//   REACT_APP_NAKAMA_KEY : la server_key publique (côté client, normal)
const env = process.env;

export const nakama = {
  url: (env.REACT_APP_NAKAMA_URL || '').replace(/\/$/, ''),
  key: env.REACT_APP_NAKAMA_KEY || 'defaultkey',
  enabled: !!env.REACT_APP_NAKAMA_URL,
};

// Leaderboards connus (alignés sur les modules Lua + les clients de jeux).
export const LEADERBOARDS = [
  { id: 'vg_level', game: '⭐ Niveau global', kind: 'level' }, // XP total tous jeux confondus (vg_progression)
  { id: 'saga_versus', game: 'Saga (versus)' },        // futur
  { id: 'worms_highscores', game: 'VertiVers Battle' },
  { id: 'medieval_highscores', game: 'Medieval RPG' },
  { id: 'bomberman_highscores', game: 'Bomberman' },
  { id: 'fishgame_highscores', game: 'Fish Game' },
];
